{
  "version": 1,
  "asset_id": "510a534c-8ae2-4068-b8f4-5d4cd11d7478",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/510a534c-8ae2-4068-b8f4-5d4cd11d7478/libera7.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/510a534c-8ae2-4068-b8f4-5d4cd11d7478/libera7.webp",
  "original_filename": "libera7.webp",
  "size": 92964,
  "content_type": "image/webp",
  "created_at": "2026-08-07T10:19:20Z"
}
